import React, { useState } from 'react'
import { UAParser } from 'ua-parser-js'
import smsLink from '#src/services/smsLink'
import {
  Button,
  SimpleModal,
  ModalTitle,
  ModalContent,
  ModalFooter,
  TextField
} from '@deal/components'

interface Props {
  onRequestClose: () => void
  smsShortenedUrl: string
}

const SmsModal: React.SFC<Props> = ({ onRequestClose, smsShortenedUrl }) => {
  const [phoneNumber, setPhoneNumber] = useState('')

  return (
    <SimpleModal isOpen={true} onRequestClose={onRequestClose}>
      <ModalTitle>Send to a friend</ModalTitle>
      <ModalContent>
        <p>Share with a friend via text!</p>
        <TextField
          value={phoneNumber}
          display="standard"
          autoFocus={false}
          label="Enter a phone number"
          labelHidden={true}
          onChange={e => setPhoneNumber(e.target.value)}
        />
      </ModalContent>
      <ModalFooter>
        <Button
          disabled={!phoneNumber}
          onClick={() => {
            const parser = new UAParser()
            const os = parser.getOS()
            onRequestClose()
            window.location.replace(
              smsLink(
                os,
                phoneNumber,
                `I shopped with a Curated expert and got hooked up with great advice and a killer deal. Sign up through my link to get 10% off your first purchase ${smsShortenedUrl}.`
              )
            )
          }}
          variant="contrast"
        >
          Okay!
        </Button>
      </ModalFooter>
    </SimpleModal>
  )
}

export default SmsModal
